<template>
  <div id="container">
    <a-layout id="layout-container">
      <a-layout-header id="header">
        <span>IREM Cap rate MAP</span>
      </a-layout-header>
      <a-layout-content id="body">
        <div class="search-container">
          <SerachBox />
          <!-- <ClickModeSelector /> -->
        </div>
        <div class="main-container">
          <GoogleMap />
        </div>
      </a-layout-content>
      <!-- <a-layout-footer>Footer</a-layout-footer> -->
    </a-layout>
  </div>
</template>

<script>
// @ is an alias to /src
import GoogleMap from "@/components/GoogleMap.vue";
import SerachBox from "@/components/SerachBox.vue";
// import ClickModeSelector from "@/components/ClickModeSelector.vue"

export default {
  name: "",
  components: {
    GoogleMap,
    SerachBox,
    // ClickModeSelector,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
#container {
  height: 100%;
}

#layout-container {
  min-width: 1024px;
  height: 100%;
  display: flex;
  flex-flow: column;
}

#body {
  padding: 10px;
  flex: 1;
  display: flex;
  flex-flow: column;
}

#header {
  font-size: 24px;
  text-align: left;
  height: 36px;
  line-height: 1.5;
  padding-left: 20px;
  color: white;
}

.search-container {
  width: 100%;
}

.main-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 129px);
}

#components-layout-demo-basic {
  text-align: center;
}

#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  background: #013255;
  color: #fff;
}

#components-layout-demo-basic .ant-layout-footer {
  line-height: 1.5;
}

#components-layout-demo-basic .ant-layout-sider {
  background: #3ba0e9;
  color: #fff;
  line-height: 120px;
}

#components-layout-demo-basic > ant-layout-content {
  background: rgba(16, 142, 233, 1);
  color: #fff;
  min-height: 120px;
  line-height: 120px;
}

#components-layout-demo-basic > .ant-layout {
  margin-bottom: 48px;
}

#components-layout-demo-basic > .ant-layout:last-child {
  margin: 0;
}
</style>
